import React from 'react';

import cls from 'classnames';

import RatingWithText from '@ott/rating-with-text';
import declOfNum from '@ott/utility-decl-of-num';

import { formatNumber } from '../../helpers/formatNumber';

import styles from './Rating.scss';

type Props = {
  className?: string;
  rating?: {
    marksCount: number;
    reviewsCount: number;
    value: number;
  };
};

const reviewsDecl = ['отзыв', 'отзыва', 'отзывов'];
const marksDecl = ['оценка', 'оценки', 'оценок'];

const Rating = ({ className, rating }: Props) => {
  if (!rating) {
    return null;
  }

  const { marksCount, reviewsCount, value } = rating;

  if (!marksCount && !reviewsCount) {
    return null;
  }

  const extra = (
    <div className={styles.extra}>
      {reviewsCount
        ? `${formatNumber(reviewsCount)} ${declOfNum(reviewsCount, reviewsDecl)}`
        : `${formatNumber(marksCount)} ${declOfNum(marksCount, marksDecl)}`}
    </div>
  );

  return (
    <RatingWithText
      className={className}
      extra={extra}
      max={10}
      min={2}
      size="small"
      value={value}
    />
  );
};

export default Rating;
